module.exports = __webpack_public_path__ + "img/homelisticon1.2b0a4491.png";